module.exports = __webpack_public_path__ + "7cc24f48556d315139a39f1c068c54e3.pdf";